import type { FeatureMatrixResponse } from '../types';
import type { RequestFn } from '../client';

/**
 * What each connector can do: payment methods, capture methods, webhook
 * flows, and whether an unverified webhook is acted on.
 */
export class FeatureMatrix {
  constructor(private readonly request: RequestFn) {}

  /** Retrieve the feature matrix. `GET /feature-matrix` */
  async retrieve(): Promise<FeatureMatrixResponse> {
    return this.request('GET', '/feature-matrix');
  }

  /**
   * Retrieve the feature matrix scoped to a merchant. Beta connectors
   * are filtered against the merchant's allowlist so the dashboard only
   * surfaces connectors the merchant can actually attach.
   * `GET /feature-matrix/{merchantId}`
   */
  async retrieveForMerchant(merchantId: string): Promise<FeatureMatrixResponse> {
    return this.request('GET', `/feature-matrix/${encodeURIComponent(merchantId)}`);
  }
}
